import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild, UrlTree, Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';
import { CommonService } from '../common/common.service';
import { FeatureToggleService } from '../feature-toggle/feature-toggle.service';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureGuardService implements CanActivateChild {
	constructor(
		private featureToggleService: FeatureToggleService,
		private commonService: CommonService,
		private configService: ConfigService
	) {}

	canActivateChild(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean|UrlTree>|Promise<boolean|UrlTree>|boolean|UrlTree {
		const categoryTag = route.data.categoryTag;
		if (categoryTag) {
			if (!this.featureToggleService.isCategoryAvailable(categoryTag)) {
				return	this.commonService.isFirstPageLoaded() ? false : this.configService.defaultRoute;
			}
		}

		const pageTag = route.data.pageTag;
		if (pageTag) {
			if (!this.featureToggleService.isPageAvailable(pageTag)) {
				return	this.commonService.isFirstPageLoaded() ? false : this.configService.defaultRoute;
			}
		}

		const featureTag = route.data.featureTag
		if (featureTag) {
			if (!this.featureToggleService.isFeatureAvailable(featureTag)) {
				return	this.commonService.isFirstPageLoaded() ? false : this.configService.defaultRoute;
			}
		}

		return true;
	}
}
